module.exports = __webpack_public_path__ + "LR.png?cd565a5c66620236523cdc248a0e882c";